import classNames from 'classnames';
import React from 'react';
import { tagColorMap } from './constants';
import { TagWrapper } from './Tags.styles';

type TTag = 'deal' | 'ev' | 'price';

type OwnProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  text: string;
  bigTag?: boolean;
  blueText?: boolean;
  tag: TTag;
};

export default function Tag({
  text,
  bigTag = false,
  blueText = false,
  tag,
  ...props
}: OwnProps) {
  return (
    <TagWrapper
      className={classNames(
        `${tagColorMap[tag]} ${blueText ? 'text-blue-6' : 'text-white'}`,
        { '!h-24 !px-16 !py-8 !text-sm leading-6': bigTag }
      )}
      {...props}
    >
      {text}
    </TagWrapper>
  );
}
